<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家账期</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.status"
                    placeholder="账期状态"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.supply_bill_status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="账单日期：">
                  <el-date-picker
                    v-model="form.bill_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="生成时间：">
                  <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div v-if="resData">
            <span>{{ resData.supply_info.supply_name }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ resData.supply_info.market_name }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ resData.supply_info.pgname }}</span>
          </div>
          <div style="position: absolute; right: 0">
            <el-form :inline="true" :model="bill_form" class="demo-form-inline">
              <el-form-item label="" style="margin-bottom: 0; margin-top: 0">
                <el-date-picker
                  v-model="bill_form.start_time"
                  disabled
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
                至
                <el-date-picker
                  v-model="bill_form.end_time"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="margin-bottom: 0; margin-top: 0">
                <el-button type="success" @click="generateSupplyBill()">
                  生成账单</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="bill_date" label="账期" align="center">
            </el-table-column>
            <el-table-column
              prop="cg_data"
              label="代采回货（+）"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.cg_sir_num }} /
                  {{ scope.row.cg_sir_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_data"
              label="退换货回货（+）"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.rj_sir_num }} /
                  {{ scope.row.rj_sir_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="退换货出库（-）"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.rj_out_num }} /
                  {{ scope.row.rj_out_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="账期生成日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_settle_status"
              label="账期状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="bill_num"
              label="账单数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-col v-if="resData" style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="curPage"
              background
              layout="total, prev, pager, next, jumper "
              :total="Number(resData.count)"
              :page-size="10"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        supply_id: 0,
      },
      bill_form: {
        start_time: "",
        end_time: "",
      },
      loading: false,
      url: "/erp/SupplySettle/getList",
      status: 100,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      const { supply_id } = this.$route.params;
      if (supply_id == "undefined" || !supply_id) {
        return this.$message.error("商家ID不存在");
      }
      this.form.supply_id = supply_id;
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.bill_form.start_time =
            res.data.data.supply_info.next_settle_start_time;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
        .map((v) => {
          return v.refund_id;
        })
        .join(",");
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/supplybilldetail/${row.settle_id}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    generateSupplyBill() {
      this.loading = true;
      const { supply_id } = this.form;
      const start = this.bill_form.start_time;
      const end = this.bill_form.end_time;
      this.$http
        .post("/erp/SupplySettle/generateSettle", {
          supply_id,
          start_time: start,
          end_time: end,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            return this.$message.error(res.data.msg);
          }
          this.resData = res.data.data;
          this.bill_form.start_time =
            res.data.data.supply_info.next_settle_start_time;
          return this.$message.success("操作成功");
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/SupplyBill.vue